import { ActionIcon, Menu, Stack, Title, useMantineTheme } from '@mantine/core'
import React, { useState } from 'react'

import OpenMenuArrow from '../Animations/OpenMenuArrow/OpenMenuArrow'
import classes from './MenuDropdown.module.css'

interface MenuDropdownProps {
  options: string[]
  title: string
  filterHeader?: boolean
  fixedOrder?: boolean
  selectedOption: string
  setSelectedOptions: (filter: string) => void
}

const MenuDropdown: React.FC<MenuDropdownProps> = ({
  options,
  title = '',
  filterHeader = false,
  selectedOption,
  fixedOrder = false,
  setSelectedOptions,
}) => {
  const theme = useMantineTheme()
  const [menuOpened, setMenuOpened] = useState(false)

  const handleOptionChange = (option: string) => {
    setSelectedOptions(option)
    if (!fixedOrder) {
      // rearrange the order of the options to get the selected one to the top
      const index = options.indexOf(option)
      options.splice(index, 1)
      options.unshift(option)
    }
    setMenuOpened(false)
  }

  const filteredOptions = options.filter(option => option !== '|')

  return (
    <Stack>
      <Menu
        trigger="hover"
        openDelay={500}
        closeDelay={60000}
        opened={menuOpened}
        onClose={() => setMenuOpened(false)}
        closeOnClickOutside
        closeOnEscape
        position="bottom"
      >
        <Menu.Target>
          <Stack
            style={{
              borderRadius: menuOpened ? '12px 12px 0 0' : '12px',
              border: filterHeader ? 'none' : `2px solid ${theme.colors.textAndIcon[0]}`,
              backgroundColor: menuOpened
                ? theme.colors.background3[0]
                : theme.colors.background[0],
            }}
            className={classes.button}
            onClick={() => setMenuOpened(!menuOpened)}
          >
            <Title style={{ fontSize: '12pt' }}>{title}</Title>
            <ActionIcon>
              <OpenMenuArrow menuOpened={menuOpened} />
            </ActionIcon>
          </Stack>
        </Menu.Target>
        <Menu.Dropdown className={classes.selectionBox}>
          {filteredOptions.map((option, index) => (
            <Stack
              key={option}
              onClick={() => handleOptionChange(option)}
              className={classes.selectionButton}
              style={{
                backgroundColor: option === selectedOption ? theme.colors.l1Primary[0] : '',
                color: option === selectedOption ? theme.colors.background[0] : '',
                borderTop:
                  options[index] === '|' ? `0.5px solid ${theme.colors.textAndIcon[0]}` : 'none',
              }}
            >
              <Stack className={classes.selectionButtonContent}>{option}</Stack>
            </Stack>
          ))}
        </Menu.Dropdown>
      </Menu>
    </Stack>
  )
}

export default MenuDropdown
